import { type ShortUrlResponse } from '@air/api/types';

type MetadataVisibilityShortUrlUpdate = {
  presentationSettings: NonNullable<ShortUrlResponse['presentationSettings']>;
  permissions?: {
    customField: Pick<ShortUrlResponse['permissions']['customField'], 'canManageApplications' | 'canView'>;
  };
};

export const buildMetadataVisibilityShortUrlUpdate = (
  showMetadata: boolean,
  presentationSettings: ShortUrlResponse['presentationSettings'],
): MetadataVisibilityShortUrlUpdate => ({
  presentationSettings: {
    ...presentationSettings,
    hideInfoTab: !showMetadata,
  },
  ...(!showMetadata
    ? {
        permissions: {
          customField: {
            canManageApplications: false,
            canView: false,
          },
        },
      }
    : {}),
});
